/**
 * PresentationEntry — opens the linked design presentation as a fade-in overlay
 * over the journey (no new window), via the shared PresentationLink.
 */

import Markdown from '../../components/Markdown.jsx'
import { J } from '../journeyUI.jsx'
import PresentationLink from './PresentationLink.jsx'
import JourneyBook from './JourneyBook.jsx'

export default function PresentationEntry({ entry, token, previewMode }) {
  const pres = entry.presentation || null
  return (
    <div>
      <div style={J.eyebrow}>Presentation</div>
      <h2 style={J.title}>{entry.title || pres?.milestoneName || 'Design presentation'}</h2>
      <hr style={J.rule} />
      {entry.data?.intro && (
        <div style={{ ...J.body, marginBottom: 22 }}><Markdown text={entry.data.intro} /></div>
      )}
      {pres && token
        ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px' }}>
            <PresentationLink
              presentation={pres} token={token} previewMode={previewMode}
              renderTrigger={({ onClick }) => <JourneyBook label="Presentation" onOpen={onClick} />}
            />
          </div>
        )
        : <div style={{ ...J.body, fontStyle: 'italic', color: '#7a9aaa' }}>This presentation is being prepared.</div>}
    </div>
  )
}
